import datapoints from '../datapoints';
import setFolderPaneStateCollapsedAndNonDynamicBit from '../utils/setFolderPaneStateCollapsedAndNonDynamicBit';
import { logVerboseUsage } from 'owa-analytics';
import { getIsBitSet } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import { getBrowserWidth } from 'owa-mail-store-actions';
import FolderPaneExpansionSource from 'owa-mail-store/lib/store/schema/FolderPaneExpansionSource';
import { getStore } from 'owa-mail-store/lib/store/Store';
import { action, select } from 'satcheljs/lib/legacy';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
export var CUT_OFF_WIDTH = 1100;
/**
 * Sets folder pane expansion state
 * @param folderPaneExpansionSource the source of the folder pane expansion
 * @param state set show folder pane state
 */
export default select({
    mailModule: function () { return getStore().mailModule; },
})(action('setShowFolderPane')(function setShowFolderPane(folderPaneExpansionSource, state) {
    var browserWidth = getBrowserWidth();
    var isCollapsedAndNonDynamic = getIsBitSet(4 /* FolderPaneStateCollapsedAndNonDynamic */);
    var _a = datapoints.TnS_FolderPaneChange.datapoint, eventName = _a.name, customData = _a.customData;
    logVerboseUsage(eventName, customData(folderPaneExpansionSource.toString(), isCollapsedAndNonDynamic, state.mailModule.showFolderPane, state.mailModule.isInNonDynamicFolderExpansionMode, browserWidth));
    if (isMailFeatureEnabled('tri-disableDynamicFolderPane')) {
        if (folderPaneExpansionSource == FolderPaneExpansionSource.LeftNavResizeExpand ||
            folderPaneExpansionSource == FolderPaneExpansionSource.ToggleExpand) {
            state.mailModule.showFolderPane = true;
        }
        else if (folderPaneExpansionSource == FolderPaneExpansionSource.ToggleCollapse) {
            state.mailModule.showFolderPane = false;
        }
        return;
    }
    if (folderPaneExpansionSource == FolderPaneExpansionSource.LeftNavResizeExpand ||
        folderPaneExpansionSource == FolderPaneExpansionSource.ToggleExpand) {
        // If user explicitly expands or user explicitly resizes folder pane, disable dynamic mode
        state.mailModule.showFolderPane = true;
        state.mailModule.isInNonDynamicFolderExpansionMode = true;
        setFolderPaneStateCollapsedAndNonDynamicBit(false /* isCollapsedAndNonDynamic */);
    }
    else if (folderPaneExpansionSource == FolderPaneExpansionSource.ToggleCollapse) {
        // If user explicitly collapses folder pane, disable dynamic mode
        state.mailModule.showFolderPane = false;
        setFolderPaneStateCollapsedAndNonDynamicBit(true /* isCollapsedAndNonDynamic */);
    }
    else if (isCollapsedAndNonDynamic) {
        // If user set folder pane to collapse explicitly then don't dynamically set folder pane width
        state.mailModule.showFolderPane = false;
    }
    else if (state.mailModule.isInNonDynamicFolderExpansionMode) {
        // If user set folder pane to expand explicitly then this is no-op
    }
    else {
        // If we are here, then show/hide folder pane based on screen size
        state.mailModule.showFolderPane = browserWidth >= CUT_OFF_WIDTH;
    }
}));
//# sourceMappingURL=setShowFolderPane.js.map